export abstract class Parser<T> {
    public abstract parse(input: object): T;
}
